// Utility to get product count in a group from basketItems
export function getProductCountInGroup(basketItems, groupId, productId) {
  if (!basketItems || !groupId || !productId) return 0;
  return basketItems
    .filter(item => {
      let itemGroupId = null;
      try {
        const ext = typeof item.extendedInfos === 'string' ? JSON.parse(item.extendedInfos) : item.extendedInfos;
        itemGroupId = ext?.mealPlan?.groupId;
      } catch {
        itemGroupId = item.groupId;
      }
      return itemGroupId === groupId && item.prodId === productId;
    })
    .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
}

